!function(){"use strict";var e={4662:function(e,t,o){o.d(t,{My:function(){return c},jW:function(){return n}});const n=(e=!1)=>{const t=window.innerWidth-document.body.offsetWidth,o=document.getElementById("nav-wrapper");e?(document.body.classList.add("no-scroll"),document.body.style.paddingRight=t+"px",o.style.paddingRight=t+"px"):(document.body.classList.remove("no-scroll"),document.body.style.paddingRight="0px",o.style.paddingRight="0px")};let i=()=>{};const r=e=>{"Escape"===e.key&&(i(),window.removeEventListener("keydown",r))},c=(e=!1,t)=>{t&&(i=t),e&&window.addEventListener("keydown",r),e||window.removeEventListener("keydown",r)};document.querySelectorAll(".local-scroll").forEach(e=>{e.addEventListener("click",e=>{e.preventDefault(),e.stopPropagation();const t=e.target.getAttribute("href");!function(e,t=0){const o=document.getElementById("nav-wrapper"),n=document.querySelector(".header").getAttribute("data-ux-position"),i=e.getBoundingClientRect().top;window.scrollTo({top:"off"!==n?i+window.scrollY-t+parseFloat(o.style.marginTop):i+window.scrollY-t,behavior:"smooth"})}(document.querySelector(t))})})}},t={};function o(n){var i=t[n];if(void 0!==i)return i.exports;var r=t[n]={exports:{}};return e[n](r,r.exports,o),r.exports}o.d=function(e,t){for(var n in t)o.o(t,n)&&!o.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)};var n=o(4662);function i(){const e=document.querySelector(".zoom-lightbox");var t,o;e&&!e.swiper.initialized?(o=e)&&o.querySelectorAll("figure:not(.figure--model)").forEach(e=>{e.addEventListener("click",()=>{s(e.parentNode.getAttribute("data-id"))})}):(t=e)&&t.swiper.on("click",function(){console.log("slider click"),this.slides[this.clickedIndex].getAttribute("data-id")&&(this.slides[this.clickedIndex].classList.contains("model")||this.slides[this.clickedIndex].classList.contains("video")||s(this.slides[this.clickedIndex].getAttribute("data-id")))})}window.addEventListener("load",i),Shopify.designMode&&document.addEventListener("shopify:section:load",i);let r,c=[];const d=()=>{(0,n.jW)(!1),(0,n.My)(!1),r&&r.classList.remove("pdp-lightbox--open"),c&&c.length&&Array.from(c).forEach(function(e){if("video"===e.tagName.toLowerCase())e.pause();else{var t=e.src;e.src=t}})};if(r=document.querySelector(".pdp-lightbox"),r){const e=r.querySelector(".pdp-lightbox__close");c=r.querySelectorAll("iframe, video"),e&&e.addEventListener("click",()=>{d()}),r.querySelectorAll(".figure--image").forEach(e=>{e.addEventListener("click",d)})}const s=e=>{(0,n.jW)(!0),(0,n.My)(!0,d),r.classList.add("pdp-lightbox--open"),(e=>{r.scrollTop=r.querySelector('figure[data-id="'+e+'"').offsetTop+parseInt(getComputedStyle(r).paddingTop)})(e)};function l(){const e=document.querySelectorAll(".scroll-atc"),t=document.querySelectorAll(".sticky-add-to-cart");2===t.length&&t[1].remove();const o=t[0];o&&document.body.prepend(o);const n=document.querySelector(".sticky-add-to-cart__inner"),i=document.querySelector(".main-product__add-to-cart .button--add-to-cart");i&&o&&new window.IntersectionObserver(([e])=>{if(e.isIntersecting)return o.classList.remove("active"),void n.classList.remove("sticky-priority");e.boundingClientRect.top>0?(o.classList.remove("active","sticky-subheader"),n.classList.remove("sticky-priority")):(o.classList.add("active","sticky-subheader"),n.classList.add("sticky-priority"))},{root:null,threshold:1}).observe(i),e&&e.forEach(e=>{e.addEventListener("click",function(e){const t=document.querySelector(".main-product__add-to-cart"),o=document.getElementById("nav-wrapper"),n=document.querySelector(".main-product__variant-selector");let i=150,r=t.offsetTop;o&&(i=o.clientHeight),n&&(r=n.getBoundingClientRect().top+window.scrollY-i);const c=r-i;window.scrollTo({top:c,behavior:"smooth"}),setTimeout(function(){n.classList.add("ux-shake"),setTimeout(function(){n.classList.remove("ux-shake")},800)},800)})})}window.addEventListener("load",l),Shopify.designMode&&document.addEventListener("shopify:section:load",l)}();



function initProductThumbSync(productId) {
  const mainEl = document.querySelector(`#gallery-main-product-${productId}`);
  const thumbsEl = document.querySelector('.product-thumbs-swiper');

  if (!mainEl || !thumbsEl) return;

  const mainSwiper = mainEl.swiper;
  const thumbsSwiper = thumbsEl.swiper;

  if (!mainSwiper || !thumbsSwiper) return;

  const getThumbSlides = () =>
    Array.from(thumbsEl.querySelectorAll('swiper-slide'));

  const clearActive = () => {
    getThumbSlides().forEach(slide =>
      slide.classList.remove('is-active')
    );
  };

  const activateByMediaId = (mediaId) => {
    requestAnimationFrame(() => {
      clearActive();

      const slides = getThumbSlides();
      const target = slides.find(slide =>
        slide.querySelector(`[data-media-id="${mediaId}"]`)
      );

      if (!target) return;

      target.classList.add('is-active');

      const index = slides.indexOf(target);
      if (index > -1) {
        thumbsSwiper.slideTo(index, 300);
      }
    });
  };

  // MAIN → THUMBS
  mainSwiper.on('slideChangeTransitionEnd', () => {
    const slide = mainSwiper.slides[mainSwiper.activeIndex];
    if (slide?.dataset?.id) {
      activateByMediaId(slide.dataset.id);
    }
  });

  // THUMBS → MAIN
  getThumbSlides().forEach((slide, index) => {
    slide.addEventListener('click', () => {
      const img = slide.querySelector('[data-media-id]');
      if (!img) return;

      const mediaId = img.dataset.mediaId;
      const targetIndex = mainSwiper.slides.findIndex(
        s => s.dataset.id === mediaId
      );

      if (targetIndex !== -1) {
        mainSwiper.slideTo(targetIndex);
        activateByMediaId(mediaId);
      }
    });
  });

  // INITIAL
  const initial = mainSwiper.slides[mainSwiper.activeIndex];
  if (initial?.dataset?.id) {
    activateByMediaId(initial.dataset.id);
  }
}

function waitForSwiper(el, cb) {
  if (el?.swiper) {
    cb(el.swiper);
  } else {
    requestAnimationFrame(() => waitForSwiper(el, cb));
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const productId = document
    .querySelector('[id^="gallery-main-product-"]')
    ?.id
    ?.replace('gallery-main-product-', '');

  if (!productId) return;

  const mainEl = document.querySelector(`#gallery-main-product-${productId}`);
  const thumbsEl = document.querySelector('.product-thumbs-swiper');

  if (!mainEl || !thumbsEl) return;

  waitForSwiper(mainEl, () => {
    waitForSwiper(thumbsEl, () => {
      initProductThumbSync(productId);
    });
  });
});
